import { BigNumber } from 'ethers'

export const isLimitExceeds = (
  inputAmount: BigNumber,
  protocolAmount: BigNumber,
  limit: BigNumber,
) => (limit.isZero() ? false : inputAmount.add(protocolAmount).gt(limit))
